export const PayxIcon = ({
  width,
  height,
  isDark,
}: {
  width: number
  height: number
  isDark: boolean
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1598 377"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="whitespace-nowrap"
  >
    <g clipPath="url(#clip0_payx_12526)">
      <path
        d="M205.08 0.429688C234.831 0.429688 260.57 5.61013 282.298 15.971C304.026 26.3319 320.573 40.8706 331.938 59.587C343.638 78.3035 349.488 100.028 349.488 124.76C349.488 149.493 343.638 171.217 331.938 189.934C320.573 208.316 304.026 222.855 282.298 233.55C260.57 243.911 234.831 249.091 205.08 249.091H39.1106V178.904H200.567C220.289 178.904 235.666 174.058 246.697 164.366C258.063 154.673 263.746 141.471 263.746 124.76C263.746 107.715 258.063 94.5133 246.697 85.155C235.666 75.4626 220.289 70.6164 200.567 70.6164H46.6318L85.241 30.0084V376.43H0V0.429688H205.08Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M415.703 297.219V228.035H676.44V297.219H415.703ZM602.731 0.429688L778.729 376.43H687.972L534.037 35.0217H562.117L408.181 376.43H317.425L493.422 0.429688H602.731Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        d="M884.771 376.43V194.947H970.012V376.43H884.771ZM707.771 0.429688H802.538L947.448 183.416H906.332L1051.24 0.429688H1146.01L954.468 242.574L899.813 243.075L707.771 0.429688Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1181.57 0L1335.78 185.159L1334.32 186.829L1335.77 185.191L1384 241.029L1384.01 241.019L1498.19 376.337H1598L1435.59 184.436L1592.61 0H1494.6L1387.6 129.539L1281.12 0H1181.57ZM1369.3 258.075L1321.16 201.908L1169 376.337H1267.27L1369.3 258.075Z"
        fill={isDark ? 'white' : '#0D1117'}
      />
      <g clipPath="url(#clip1_payx_12526)">
        <path
          d="M1267.27 376.334L1369.29 258.076L1321.15 201.913L1169 376.334H1267.27Z"
          fill="#008080"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_payx_12526">
        <rect width="1598" height="377" fill="white" />
      </clipPath>
      <clipPath id="clip1_payx_12526">
        <rect width="429" height="174.424" fill="white" transform="translate(1169 201.913)" />
      </clipPath>
    </defs>
  </svg>
)
